export default "__VITE_ASSET__B1ow9Z_d__"